const {
  callAuthorizedGraphQLEndpoint,
} = require('../../../../../Module/graphQL')

export const createCampaignClientCodes = queryVars => {
  return callAuthorizedGraphQLEndpoint(
    `mutation ($input: CreateCampaignClientCodes!) {
      createCampaignClientCodes(input:$input){
        trackingType
        campaignId
        clientCodes{
          id
          clientCode
          clientLink
          city{
            id
            name
          }
        }
      }
    }`,
    {
      input: queryVars,
    },
  )
}
